import script from "./BrandedTitleElementProduction.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./BrandedTitleElementProduction.vue?vue&type=script&lang=js"
export * from "./BrandedTitleElementProduction.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./BrandedTitleElementProduction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/text-element/BrandedTitleElementProduction.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3012adcc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3012adcc', __exports__)) {
    api.reload('3012adcc', __exports__)
  }
  
}


export default __exports__